<template>
  <div>
    <!-- 页面标题抬头 -->
    <h3>
      <el-page-header @back="$router.push('./equip')" :content="title" />
    </h3>
    <el-card>
      <el-form ref="equipFrom" :model="form" label-width="150px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="MAC号" style="width: 50%" prop="sn">
              <el-input
                v-model="form.sn"
                :disabled="form.id != undefined"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="园区" prop="parkId">
              <el-select
                v-model="form.parkId"
                @change="landOptionGet"
                :disabled="form.id != undefined"
                size="small"
              >
                <el-option
                  v-for="item in parkOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备所属平台" prop="platform">
              <el-select
                v-model="form.platform"
                @change="selectPlatform"
                :disabled="form.id != undefined"
                size="small"
              >
                <el-option
                  v-for="item in descArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="model">
              <el-select
                v-model="form.model"
                @change="selectModel"
                :disabled="form.id != undefined"
                size="small"
              >
                <el-option
                  v-for="item in modelsArr"
                  :key="item.name"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-col>
              <el-form-item label="">
                <el-button type="warning" @click="clearFrom">清空</el-button>
                <el-popconfirm
                  title="下一步后，以上内容将无法编辑。"
                  @confirm="next"
                  @cancel="cancel"
                >
                  <el-button type="primary" slot="reference">下一步</el-button>
                </el-popconfirm>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="12" v-if="slot !== 'park'">
            <div style="text-align: right">
              <el-button type="primary" @click="save">填好了，保存</el-button>
            </div>
            <div v-if="slot === 'land'">
              <span>单设备对应多地块</span>
              <div id="container">
                <div class="left">
                  <ul>
                    <li
                      v-for="(item, index) in facilityEquipName"
                      :key="'left' + index"
                      :id="item.id"
                      name="source"
                    >
                      {{ item.sn }}
                    </li>
                  </ul>
                </div>
                <div class="right">
                  <ul>
                    <li
                      v-for="(item, index) in landOption"
                      :key="'right' + index"
                      :id="item.id"
                      name="target"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <span>多线路对应多地块</span>
              </div>
              <div id="container">
                <div class="left">
                  <ul>
                    <li
                      v-for="(item, index) in irrigateArr"
                      :key="'left' + index"
                      :id="item.value"
                      name="source"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>

                <div class="right">
                  <ul>
                    <li
                      v-for="(item, index) in landOption"
                      :key="'right' + index"
                      :id="item.id"
                      name="target"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import jsPlumb from 'jsplumb'
import deviceProfile from '@/common/device-profile.js'
import { getParksInEnterprise } from '@/api/park2.js'
import { getLandInPark } from '@/api/land2.js'
import {
  addDevice,
  getDeviceById,
  getDevicesByParkId,
  setIrrigateDeviceToLand,
  setFacilityDeviceToLand,
  getIrrigateRelationsByDeviceId,
} from '@/api/equip.js'
export default {
  data() {
    return {
      form: {
        id: undefined,
        sn: '',
        model: '',
        parkId: '',
        platform: '',
      },
      facilityEquipName: [], //facility设备对应多地块
      irrigateArr: [
        { name: '一路', value: '1' },
        { name: '二路', value: '2' },
        { name: '三路', value: '3' },
        { name: '四路', value: '4' },
        { name: '五路', value: '5' },
        { name: '六路', value: '6' },
        { name: '七路', value: '7' },
        { name: '八路', value: '8' },
        { name: '九路', value: '9' },
        { name: '十路', value: '10' },
      ], //irrigate设备十六路对应单地块
      relations: [], //连线后id存放的数组
      relationsEdit: [],
      parkOption: [],
      landOption: [],
      descArr: [], // 设备所属平台
      modelsArr: [], //平台下设备类型
      showLand: false, //地块选择器显示隐藏
      landId: undefined,
      slot: 'park', //设备类型
      rules: {
        sn: [{ required: true, message: 'MAC号不能为空', trigger: 'blur' }],
        platform: [
          { required: true, message: '设备平台不能为空', trigger: 'blur' },
        ],
        parkId: [{ required: true, message: '园区不能为空', trigger: 'blur' }],
        model: [
          { required: true, message: '设备类型不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    if (this.$route.query.id !== undefined) {
      this.init(this.$route.query.id)
    }
  },
  mounted() {
    this.getSelectOptions()
    this.form.id = this.$route.query.id
  },
  beforeDestroy() {
    this.jsPlumb = jsPlumb.jsPlumb.getInstance()
    this.jsPlumb.repaintEverything()
  },
  computed: {
    title() {
      return `${isNaN(this.$route.query.id) ? '新增' : '编辑'}设备`
    },
  },
  methods: {
    cancel(){},
    //所有下拉选项
    getSelectOptions() {
      // 园区
      getParksInEnterprise(this.$store.getters.currentEnterprise.id).then(
        (data) => {
          this.parkOption = data.data
        }
      )
      // 平台
      this.descArr = deviceProfile.map((item) => {
        return { label: item.desc, value: item.name }
      })
    },
    // 选中平台后，展示对应设备类型
    selectPlatform(value) {
      this.modelsArr = deviceProfile.find((e) => e.name === value).models
      this.modelsArr = this.modelsArr.map((item) => {
        return {
          label: item.name + '(' + item.desc + ')',
          value: item.name,
          ...item,
        }
      })
    },
    // 选中类型后，是否展示地块选择，并且确定是单选还是多选
    selectModel(value) {
      this.form.model = value.name
      this.form.slot = value.slot
    },
    //数据连线功能
    landOptionGet() {
      getLandInPark(this.form.parkId).then((data) => {
        this.landOption = data.data
        this.$nextTick(() => {
          let defaultConfig = {
            Container: 'container', // 选择器id
            EndpointStyle: { radius: 0.11, fill: '#999' }, // 端点样式
            PaintStyle: { stroke: '#999', strokeWidth: 4 }, // 绘画样式，默认8px线宽  #456
            HoverPaintStyle: { stroke: '#994B0A', strokeWidth: 4 }, // 默认悬停样式  默认为null
            ConnectionOverlays: [
              // 此处可以设置所有箭头的样式
              [
                'Arrow',
                {
                  // 设置参数可以参考中文文档
                  location: 1,
                  length: 12,
                  paintStyle: {
                    stroke: '#999',
                    fill: '#999',
                  },
                },
              ],
            ],
            Connector: ['Straight'], // 要使用的默认连接器的类型：直线，折线，曲线等
            DrapOptions: { cursor: 'crosshair', zIndex: 2000 },
          }
          let jsPlumbConnectOptions = {
            isSource: true,
            isTarget: true,
            // 动态锚点、提供了4个方向 Continuous、AutoDefault
            anchor: 'Continuous',
            overlays: [['Arrow', { width: 8, length: 8, location: 1 }]], // overlay
          }
          this.jsPlumb = jsPlumb.jsPlumb.getInstance()
          this.jsPlumb.importDefaults(defaultConfig)
          this.relations.forEach((item) => {
            jsPlumb.jsPlumb.ready(() => {
              this.jsPlumb.connect(
                {
                  source: item[0],
                  target: item[1],
                },
                jsPlumbConnectOptions
              )
            })
          })
          if (this.form.model === 'facility') {
            this.jsPlumb.batch(() => {
              for (let i = 0; i < this.facilityEquipName.length; i++) {
                this.initLeaf(this.facilityEquipName[i].id, 'source')
              }
              for (let j = 0; j < this.landOption.length; j++) {
                this.initLeaf(this.landOption[j].id, 'target')
              }
            })
          }
          if (this.form.model === 'irrigate') {
            for (let i = 0; i < this.irrigateArr.length; i++) {
              this.initLeaf(this.irrigateArr[i].value, 'source')
            }
            for (let j = 0; j < this.landOption.length; j++) {
              this.initLeaf(this.landOption[j].id, 'target')
            }
          }
          this.setjsPlumb(true, true)
          //连线时触发
          this.jsPlumb.bind('connection', (conn, originalEvent) => {
            this.landId = conn.targetId
            let arr2 = { route: conn.sourceId, landId: conn.targetId }
            this.relationsEdit.push(arr2)
          })
          // 单线删除
          this.jsPlumb.bind('click', (conn, originalEvent) => {
            this.jsPlumb.deleteConnection(conn)
            this.relations.splice(
              this.relations.findIndex((e) => e === conn.targetId),
              1
            )
            this.relationsEdit.splice(
              this.relationsEdit.findIndex((e) => e.landId === conn.targetId),
              1
            )
          })
        })
      })
    },
    init(id) {
      getDeviceById(id).then((data) => {
        console.log(data.data)
        this.facilityEquipName = [data.data]
        Object.keys(this.form).forEach((item) => {
          this.form[item] = data.data[item]
        })
        if (data.data.model === 'branch-land') {
          getIrrigateRelationsByDeviceId(data.data.id).then((r) => {
            r.data.forEach((item) => {
              let arr1 = [item.route.toString(), item.landId.toString()]
              let arr2 = {
                route: item.route.toString(),
                landId: item.landId.toString(),
              }
              this.relations.push(arr1)
              this.relationsEdit.push(arr2)
            })
            this.landOptionGet()
          })
        } else if (data.data.model === 'house') {
          getLandInPark(this.$route.query.parkId).then((r) => {
            this.landOption = r.data
          })
            this.landOptionGet()
          let arr = [data.data.id.toString(), data.data.landId.toString()]
          this.relations.push(arr)
        }
      })
    },
    clearFrom() {
      this.$refs.equipFrom.resetFields()
    },
    next() {
      this.slot = this.form.slot
      delete this.form.slot
      this.$refs.equipFrom.validate((valid) => {
        if (this.form.id == undefined) {
          if (valid) {
            addDevice(this.form).then((data) => {
              getDevicesByParkId(this.form.parkId).then((r) => {
                let id = r.data.find((e) => e.sn === this.form.sn).id
                this.init(id)
              })
              //   this.$router.push('equip')
              // this.init
            })
          }
        } else {
          this.line()
        }
      })
    },
    save() {
      this.line()
    },
    //数据连线
    line() {
      if (this.slot == 'land') {
        setFacilityDeviceToLand(this.form.id, this.landId).then((data) => {
          this.$router.push('equip')
        })
      } else {
        setIrrigateDeviceToLand(this.form.id, this.relationsEdit).then(() => {
          this.$router.push('equip')
        })
      }
    },
    initLeaf(id, type) {
      const ins = this.jsPlumb
      const elem = document.getElementById(id)
      if (type === 'source') {
        ins.makeSource(elem, {
          anchor: [1, 0.5, 0, 0], // 左 上 右 下
          allowLoopback: false, //允许回连
          maxConnections: 1, //最大连接数（-1表示不限制）
        })
      } else {
        ins.makeTarget(elem, {
          anchor: [0, 0.5, 0, 0],
          allowLoopback: false,
          maxConnections: -1,
        })
      }
    },
    setjsPlumb(sourceFlag, targetFlag) {
      const source = document.getElementsByName('source')
      const target = document.getElementsByName('target')
      this.jsPlumb.setSourceEnabled(source, sourceFlag)
      this.jsPlumb.setTargetEnabled(target, targetFlag)
    },
  },
}
</script>
<style scoped>
#container {
  width: 500px;
  height: 500px;
  padding: 20px;
  position: relative; /*一定加上这句，否则连线位置发生错乱*/
}

.left {
  float: left;
  width: 150px;
}
.right {
  float: right;
  width: 250px;
}

.left li,
.right li {
  text-align: center;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #efefef;
  margin-bottom: 20px;
  padding: 8px 5px;
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/resource/equip/EquipEditor.vue